import { backendApi } from "./backendApi.rtkq";

export interface SpeakerIdentificationData {
  id: string;
  transcriptionId: string;
  userId: string;
  resultHtml?: string;
  resultJson?: {
    speakers: Array<{
      index: number;
      speakerId: string;
      speaker: string;
      text: string;
    }>;
  };
  status: "processing" | "completed" | "failed";
  model: string;
  createdAt: string;
  completedAt?: string;
  processingTimeMs?: number;
  error?: string;
  usage?: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
  };
}

export interface GetLatestSpeakerIdentificationParams {
  userId: string;
  transcriptionId: string;
}

export interface GenerateSpeakerIdentificationParams {
  userId: string;
  transcriptionId: string;
}

export interface UpdateSpeakerNamesParams {
  userId: string;
  transcriptionId: string;
  speakerMappings: Record<string, string>;
}

export const speakerIdentificationApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getLatestSpeakerIdentification: builder.query<
      SpeakerIdentificationData | null,
      GetLatestSpeakerIdentificationParams
    >({
      query: ({ transcriptionId }) => `/transcriptions/${transcriptionId}/speakers`,
      transformResponse: (response: SpeakerIdentificationData | null) => response ?? null,
      providesTags: (_result, _error, { userId, transcriptionId }) => [
        { type: "SpeakerIdentifications", id: `${userId}-${transcriptionId}` },
      ],
    }),

    generateSpeakerIdentification: builder.mutation<
      SpeakerIdentificationData,
      GenerateSpeakerIdentificationParams
    >({
      query: ({ transcriptionId }) => ({
        url: `/transcriptions/${transcriptionId}/speakers`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, { userId, transcriptionId }) => [
        { type: "SpeakerIdentifications", id: `${userId}-${transcriptionId}` },
      ],
    }),

    updateSpeakerNames: builder.mutation<SpeakerIdentificationData, UpdateSpeakerNamesParams>({
      query: ({ transcriptionId, speakerMappings }) => ({
        url: `/transcriptions/${transcriptionId}/speakers/names`,
        method: "PUT",
        body: { speakerMappings },
      }),
      invalidatesTags: (_result, _error, { userId, transcriptionId }) => [
        { type: "SpeakerIdentifications", id: `${userId}-${transcriptionId}` },
      ],
    }),
  }),
});

export const {
  useGetLatestSpeakerIdentificationQuery,
  useGenerateSpeakerIdentificationMutation,
  useUpdateSpeakerNamesMutation,
} = speakerIdentificationApi;
